var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocuments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0968e3",
    fillOpacity: 1,
    d: "M18.5 20a.5.5 0 01-.5.5h-5.732A6.518 6.518 0 0111.19 22H18a2 2 0 002-2V9.828a2 2 0 00-.586-1.414l-5.829-5.828a.491.491 0 00-.049-.04.63.63 0 01-.036-.03 2.072 2.072 0 00-.219-.18.652.652 0 00-.08-.044l-.048-.024-.05-.029c-.054-.031-.109-.063-.166-.087a1.977 1.977 0 00-.624-.138c-.02-.001-.04-.004-.059-.007A.605.605 0 0012.172 2H6a2 2 0 00-2 2v7.498a6.451 6.451 0 011.5-.422V4a.5.5 0 01.5-.5h6V8a2 2 0 002 2h4.5v10zm-5-15.379L17.378 8.5H14a.5.5 0 01-.5-.5V4.621zM12 17.5a5.5 5.5 0 10-11 0 5.5 5.5 0 0011 0zM7 18l.001 2.503a.5.5 0 11-1 0V18H3.496a.5.5 0 010-1H6v-2.5a.5.5 0 111 0V17h2.497a.5.5 0 010 1H7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.8c62bb882bd3ec80ac3a989f6e3950dd.svg";
export { ForwardRef as ReactComponent };